// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================
   NAVBAR BASE
========================= */
.custom-navbar-admin {
  background-color: #ebebebd1 !important;
  display: flex;
  align-items: center;
  flex-wrap: nowrap !important;
  width: 100%;
  min-height: 80px;
  padding: 0 12px;
  position: relative;
  z-index: 1001 !important;
  overflow: visible !important;
}

/* Logo (evita empujar el bloque derecho) */
.custom-navbar-admin .app-brand-link {
  display: inline-flex;
  align-items: center;
  min-width: 0;
  flex: 0 1 auto;
}

.custom-navbar-admin .app-brand-link img {
  display: block;
  height: 80px;
  width: auto;
  max-width: 100%;
  object-fit: contain;
}

/* =========================
   BLOQUE DERECHO (campana + usuario)
========================= */
.custom-navbar-admin .navbar-nav-right {
  display: flex !important;
  align-items: center !important;
  margin-left: auto !important;
  flex: 0 0 auto !important;
  white-space: nowrap;
  min-width: 0;
}

/* ✅ UL acciones (IMPORTANTE para que no se rompa el layout) */
.custom-navbar-admin .navbar-nav-right .navbar-actions {
  display: inline-flex !important;
  align-items: center !important;
  gap: 10px;
  margin: 0;
  padding: 0;
  list-style: none;
}

/* =========================
   RESET BOTONES (campana/avatar)
========================= */
.btn-reset {
  appearance: none;
  border: 0 !important;
  background: transparent !important;
  padding: 0 !important;
  margin: 0 !important;
  line-height: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  cursor: pointer !important;
}

/* =========================
   NOTIFICACIÓN (CAMPANA + BADGE)
========================= */
.nav-notify {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.notification-icon {
  position: relative;
}

/* badge rojo */
.notificationsCount {
  position: absolute;
  top: -6px;
  right: -8px;
  background: red;
  color: #fff;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 999px;
  line-height: 1;
  z-index: 2;
}

/* =========================
   AVATAR (SIEMPRE VISIBLE)
========================= */
.nav-avatar {
  display: inline-flex !important;
  align-items: center !important;
}

.nav-avatar .nav-link {
  padding: 0 !important;
}

/* ✅ fuerza tamaño estable del avatar (evita que "desaparezca") */
.avatar-img {
  width: 38px !important;
  height: 38px !important;
  object-fit: cover !important;
  border-radius: 999px !important;
  display: block !important;
}

/* Patrón único de plataforma para cualquier hamburguesa integrada al navbar. */
.platform-navbar-menu-toggle {
  appearance: none !important;
  -webkit-appearance: none !important;
  display: none;
  align-items: center;
  justify-content: center;
  flex: 0 0 44px;
  width: 44px;
  height: 44px;
  margin-right: 8px;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: none !important;
  background-color: transparent !important;
  background-image: none !important;
  box-shadow: none !important;
  outline: none !important;
  color: #006699;
  font-size: 25px;
  line-height: 1;
  cursor: pointer;
}

.platform-navbar-menu-toggle:hover,
.platform-navbar-menu-toggle:focus,
.platform-navbar-menu-toggle:focus-visible,
.platform-navbar-menu-toggle:active {
  background: none !important;
  background-color: transparent !important;
  background-image: none !important;
  box-shadow: none !important;
  outline: none !important;
}

.platform-navbar-menu-toggle,
.platform-navbar-menu-toggle:focus {
  appearance: none !important;
  -webkit-appearance: none !important;
  outline: 0 !important;
}

.platform-navbar-menu-toggle:hover,
.platform-navbar-menu-toggle:focus-visible {
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
}

.platform-navbar-menu-toggle:active {
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
}

@media (max-width: 1199px) {
  /* Contrato visual único para las barras que integran navegación lateral. */
  .platform-responsive-navbar {
    min-height: 64px !important;
    padding: 4px 12px 4px 8px !important;
    background: transparent !important;
    box-shadow: none !important;
  }

  .platform-responsive-navbar .app-brand-link {
    min-width: 0;
    flex: 1 1 auto;
  }

  .platform-responsive-navbar .app-brand-link img {
    width: min(190px, 100%);
    height: 56px !important;
    object-fit: contain;
    object-position: left center;
  }

  .platform-responsive-navbar .navbar-nav-right {
    position: static;
    transform: none;
    flex: 0 0 auto;
  }

  .platform-responsive-navbar .navbar-actions {
    gap: 4px;
  }

  .custom-navbar-admin > .platform-navbar-menu-toggle {
    display: inline-flex;
  }
}

/* Preview zona horaria (dropdown/offcanvas usuario) */
.timezone-preview {
  margin: 4px 0 8px;
  padding: 6px 8px;
  border: 0;
  border-radius: 0;
  background: transparent;
  width: 100%;
  box-sizing: border-box;
}

.timezone-preview-line {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  line-height: 1.25;
  margin-bottom: 0;
}

.timezone-preview-zone {
  color: #516783;
  font-size: 11px;
  font-weight: 500;
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.timezone-preview-clock {
  color: #2d3f58;
  font-size: 11px;
  font-weight: 600;
  flex-shrink: 0;
}

/* Dropdown usuario: hover ocupa la fila completa */
.navbar-dropdown .dropdown-menu>li {
  margin: 0;
  padding: 0;
}

.navbar-dropdown .dropdown-menu>li>a.dropdown-item,
.navbar-dropdown .dropdown-menu>li>button.dropdown-item {
  display: flex;
  align-items: center;
  width: 100%;
  margin: 0;
  padding: 10px 16px;
  border-radius: 0;
  box-sizing: border-box;
}

.navbar-dropdown .dropdown-menu>li>a.dropdown-item:hover,
.navbar-dropdown .dropdown-menu>li>button.dropdown-item:hover,
.navbar-dropdown .dropdown-menu>li>a.dropdown-item:focus,
.navbar-dropdown .dropdown-menu>li>button.dropdown-item:focus {
  background-color: #edf3fb;
}

/* Si hay estilos del template que esconden/rompen el img */
#avtarIcon,
#avtarIcon img {
  max-width: none !important;
  overflow: visible !important;
}

/* =========================
   NOTIFICACIONES (DESKTOP)
========================= */
#notificationDropdown {
  position: absolute;
  top: 100%;
  right: 0;
  width: 520px;
  max-height: calc(100vh - 200px);
  z-index: 2500;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
}

/* ✅ Notificaciones: nunca se sale del contenedor (desktop + mobile) */
#notificationDropdown,
#notificationDropdown * {
  box-sizing: border-box;
}

/* Evita scroll horizontal en el panel */
#notificationDropdown {
  overflow-x: hidden !important;
}

/* El contenedor scroll interno también sin X */
#notificationDropdown .dropdown-body-scroll {
  overflow-x: hidden !important;
}

/* Cada item: permite partir palabras largas */
.notification-item {
  width: 100%;
  min-width: 0;
  /* CLAVE en layouts flex */
  overflow: hidden;
}

.notification-title {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  min-width: 0;
  /* CLAVE para que el texto envuelva */
}

.notification-title-text,
.notification-item strong,
.notification-item div,
.notification-item span {
  white-space: normal !important;
  overflow-wrap: anywhere;
  /* rompe cadenas largas */
  word-break: break-word;
}

/* =========================
   SOLICITUDES (LISTA)
   - fuerza 100% ancho
   - evita desbordes
========================= */

/* UL contenedor siempre 100% */
#notificationDropdown ul,
.offcanvas-body ul {
  width: 100%;
  margin: 0;
  padding: 0;
}

/* LI solicitud ocupa TODO el ancho */
.solicitudesResponsive {
  width: 100% !important;
  display: flex !important;
  align-items: stretch !important;
  gap: 10px;
  list-style: none !important;
  box-sizing: border-box;
}

/* Quita limitaciones típicas de .dropdown-item (bootstrap) */
#notificationDropdown .dropdown-item.solicitudesResponsive {
  white-space: normal !important;
}

/* Contenedor de textos (el div con flexDirection column) */
.solicitudesResponsive>div {
  flex: 1 1 auto !important;
  min-width: 0 !important;
  /* CLAVE para ellipsis */
}

/* Ellipsis para spans (NombreEmpresa / Ruta / Nota) */
.solicitudesResponsive span {
  min-width: 0 !important;
}

/* Botón Aceptar: columna fija sin romper layout */
.solicitudesResponsive .btn-aceptar {
  flex: 0 0 auto !important;
  align-self: stretch;
  white-space: nowrap;
  padding: 0 12px !important;
  border-left: 1px solid #111 !important;
}

/* Si quieres que TODO el item sea clickeable sin “huecos” */
.solicitudesResponsive:hover {
  background: rgba(0, 0, 0, 0.03);
}




/* =========================
   MOBILE (SIDEBAR 64px)
========================= */
@media (max-width: 768px) {

  .platform-responsive-navbar {
    min-height: 60px !important;
    padding: 4px 8px !important;
  }

  .platform-responsive-navbar .app-brand-link img {
    width: min(172px, 100%);
    height: 48px !important;
  }

  /* Navbar estable */
  .custom-navbar-admin {
    min-height: 80px;
    padding: 0 8px;
  }

  /* Reduce el logo en mobile para que no empuje campana/avatar */
  .custom-navbar-admin .app-brand-link img {
    height: 56px !important;
    max-width: 180px;
    object-fit: contain;
  }

  /* 👉 Bloque derecho SIEMPRE visible */
  .custom-navbar-admin .navbar-nav-right {
    position: absolute;
    top: 50%;
    right: 8px;
    transform: translateY(-50%);
    z-index: 3000;
  }

  /* Ajuste de espacio entre íconos */
  .custom-navbar-admin .navbar-nav-right .navbar-actions {
    gap: 8px;
  }

  /* Oculta username en mobile */
  .custom-navbar-admin .navbar-nav-right .fw-semibold {
    display: none !important;
  }

  /* =========================
     PANEL FULLSCREEN NOTIFICACIONES
     (respeta sidebar 64px)
  ========================= */
  #notificationDropdown.dropdown-panel {
    position: fixed !important;
    top: 80px !important;
    /* debajo del navbar */
    left: 64px !important;
    /* sidebar */
    right: 0 !important;
    bottom: 0 !important;

    width: auto !important;
    max-width: none !important;
    min-width: 0 !important;

    border-radius: 0 !important;
    border: 0 !important;
    box-shadow: none !important;

    display: flex !important;
    flex-direction: column !important;
    overflow: hidden !important;

    background: #fff !important;
    z-index: 2600 !important;
  }

  /* Backdrop SIN cubrir sidebar */
  .dropdown-panel-backdrop {
    position: fixed;
    top: 80px;
    left: 64px;
    /* sidebar */
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.25);
    z-index: 2500;
  }

  /* Header fijo */
  .dropdown-panel-header {
    position: sticky;
    top: 0;
    background: #fff;
    z-index: 2;
    padding: 10px 12px;
    border-bottom: 1px solid #ddd;
  }

  /* Body scroll */
  .dropdown-panel-body {
    flex: 1 1;
    overflow-y: auto;
    padding: 10px;
    -webkit-overflow-scrolling: touch;
  }

  /* Evita bugs de Bootstrap */
  .dropdown-menu[data-popper-placement] {
    transform: none !important;
  }

  .inputSearchNotifiaciones {
    width: 90% !important;
  }

  .backdrop-offcanvas-user.show {
    left: 64px !important;
    width: calc(100vw - 64px) !important;
  }

  .offcanvas.custom-offcanvas-user {
    left: 64px !important;
    max-width: calc(100vw - 64px) !important;
  }

  .solicitudesResponsive {
    padding: 12px 10px !important;
  }

  .solicitudesResponsive .btn-aceptar {
    padding: 0 10px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Css/navbarPrincipal.css"],"names":[],"mappings":"AAAA;;2BAE2B;AAC3B;EACE,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA,2CAA2C;AAC3C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;;2BAE2B;AAC3B;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA,8DAA8D;AAC9D;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,SAAS;EACT,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;;2BAE2B;AAC3B;EACE,gBAAgB;EAChB,oBAAoB;EACpB,kCAAkC;EAClC,qBAAqB;EACrB,oBAAoB;EACpB,yBAAyB;EACzB,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;;2BAE2B;AAC3B;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,UAAU;AACZ;;AAEA;;2BAE2B;AAC3B;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA,iEAAiE;AACjE;EACE,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA,+EAA+E;AAC/E;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,2BAA2B;EAC3B,wCAAwC;EACxC,iCAAiC;EACjC,2BAA2B;EAC3B,wBAAwB;EACxB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;;;;EAIE,2BAA2B;EAC3B,wCAAwC;EACxC,iCAAiC;EACjC,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;;EAEE,2BAA2B;EAC3B,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;;EAEE,kCAAkC;EAClC,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,2EAA2E;EAC3E;IACE,2BAA2B;IAC3B,oCAAoC;IACpC,kCAAkC;IAClC,2BAA2B;EAC7B;;EAEA;IACE,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;IACnB,4BAA4B;EAC9B;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA,sDAAsD;AACtD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,mDAAmD;AACnD;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA,2DAA2D;AAC3D;;EAEE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;;2BAE2B;AAC3B;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,sEAAsE;AACtE;;EAEE,sBAAsB;AACxB;;AAEA,wCAAwC;AACxC;EACE,6BAA6B;AAC/B;;AAEA,+CAA+C;AAC/C;EACE,6BAA6B;AAC/B;;AAEA,8CAA8C;AAC9C;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,qCAAqC;AACvC;;AAEA;;;;EAIE,8BAA8B;EAC9B,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;;;2BAI2B;;AAE3B,+BAA+B;AAC/B;;EAEE,WAAW;EACX,SAAS;EACT,UAAU;AACZ;;AAEA,qCAAqC;AACrC;EACE,sBAAsB;EACtB,wBAAwB;EACxB,+BAA+B;EAC/B,SAAS;EACT,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA,6DAA6D;AAC7D;EACE,8BAA8B;AAChC;;AAEA,2DAA2D;AAC3D;EACE,yBAAyB;EACzB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA,sDAAsD;AACtD;EACE,uBAAuB;AACzB;;AAEA,kDAAkD;AAClD;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA,4DAA4D;AAC5D;EACE,+BAA+B;AACjC;;;;;AAKA;;2BAE2B;AAC3B;;EAEE;IACE,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA,mBAAmB;EACnB;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA,+DAA+D;EAC/D;IACE,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA,sCAAsC;EACtC;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,2BAA2B;IAC3B,aAAa;EACf;;EAEA,mCAAmC;EACnC;IACE,QAAQ;EACV;;EAEA,8BAA8B;EAC9B;IACE,wBAAwB;EAC1B;;EAEA;;;6BAG2B;EAC3B;IACE,0BAA0B;IAC1B,oBAAoB;IACpB,sBAAsB;IACtB,qBAAqB;IACrB,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;;IAEpB,sBAAsB;IACtB,0BAA0B;IAC1B,uBAAuB;;IAEvB,2BAA2B;IAC3B,oBAAoB;IACpB,2BAA2B;;IAE3B,wBAAwB;IACxB,iCAAiC;IACjC,2BAA2B;;IAE3B,2BAA2B;IAC3B,wBAAwB;EAC1B;;EAEA,gCAAgC;EAChC;IACE,eAAe;IACf,SAAS;IACT,UAAU;IACV,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,+BAA+B;IAC/B,aAAa;EACf;;EAEA,gBAAgB;EAChB;IACE,gBAAgB;IAChB,MAAM;IACN,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA,gBAAgB;EAChB;IACE,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,iCAAiC;EACnC;;EAEA,4BAA4B;EAC5B;IACE,0BAA0B;EAC5B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;IACrB,oCAAoC;EACtC;;EAEA;IACE,qBAAqB;IACrB,wCAAwC;EAC1C;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* =========================\n   NAVBAR BASE\n========================= */\n.custom-navbar-admin {\n  background-color: #ebebebd1 !important;\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap !important;\n  width: 100%;\n  min-height: 80px;\n  padding: 0 12px;\n  position: relative;\n  z-index: 1001 !important;\n  overflow: visible !important;\n}\n\n/* Logo (evita empujar el bloque derecho) */\n.custom-navbar-admin .app-brand-link {\n  display: inline-flex;\n  align-items: center;\n  min-width: 0;\n  flex: 0 1 auto;\n}\n\n.custom-navbar-admin .app-brand-link img {\n  display: block;\n  height: 80px;\n  width: auto;\n  max-width: 100%;\n  object-fit: contain;\n}\n\n/* =========================\n   BLOQUE DERECHO (campana + usuario)\n========================= */\n.custom-navbar-admin .navbar-nav-right {\n  display: flex !important;\n  align-items: center !important;\n  margin-left: auto !important;\n  flex: 0 0 auto !important;\n  white-space: nowrap;\n  min-width: 0;\n}\n\n/* ✅ UL acciones (IMPORTANTE para que no se rompa el layout) */\n.custom-navbar-admin .navbar-nav-right .navbar-actions {\n  display: inline-flex !important;\n  align-items: center !important;\n  gap: 10px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n/* =========================\n   RESET BOTONES (campana/avatar)\n========================= */\n.btn-reset {\n  appearance: none;\n  border: 0 !important;\n  background: transparent !important;\n  padding: 0 !important;\n  margin: 0 !important;\n  line-height: 0 !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  cursor: pointer !important;\n}\n\n/* =========================\n   NOTIFICACIÓN (CAMPANA + BADGE)\n========================= */\n.nav-notify {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n}\n\n.notification-icon {\n  position: relative;\n}\n\n/* badge rojo */\n.notificationsCount {\n  position: absolute;\n  top: -6px;\n  right: -8px;\n  background: red;\n  color: #fff;\n  font-size: 10px;\n  padding: 2px 6px;\n  border-radius: 999px;\n  line-height: 1;\n  z-index: 2;\n}\n\n/* =========================\n   AVATAR (SIEMPRE VISIBLE)\n========================= */\n.nav-avatar {\n  display: inline-flex !important;\n  align-items: center !important;\n}\n\n.nav-avatar .nav-link {\n  padding: 0 !important;\n}\n\n/* ✅ fuerza tamaño estable del avatar (evita que \"desaparezca\") */\n.avatar-img {\n  width: 38px !important;\n  height: 38px !important;\n  object-fit: cover !important;\n  border-radius: 999px !important;\n  display: block !important;\n}\n\n/* Patrón único de plataforma para cualquier hamburguesa integrada al navbar. */\n.platform-navbar-menu-toggle {\n  appearance: none !important;\n  -webkit-appearance: none !important;\n  display: none;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 44px;\n  width: 44px;\n  height: 44px;\n  margin-right: 8px;\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n  background: none !important;\n  background-color: transparent !important;\n  background-image: none !important;\n  box-shadow: none !important;\n  outline: none !important;\n  color: #006699;\n  font-size: 25px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.platform-navbar-menu-toggle:hover,\n.platform-navbar-menu-toggle:focus,\n.platform-navbar-menu-toggle:focus-visible,\n.platform-navbar-menu-toggle:active {\n  background: none !important;\n  background-color: transparent !important;\n  background-image: none !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.platform-navbar-menu-toggle,\n.platform-navbar-menu-toggle:focus {\n  appearance: none !important;\n  -webkit-appearance: none !important;\n  outline: 0 !important;\n}\n\n.platform-navbar-menu-toggle:hover,\n.platform-navbar-menu-toggle:focus-visible {\n  background: transparent !important;\n  background-color: transparent !important;\n  box-shadow: none !important;\n}\n\n.platform-navbar-menu-toggle:active {\n  background: transparent !important;\n  background-color: transparent !important;\n  box-shadow: none !important;\n}\n\n@media (max-width: 1199px) {\n  /* Contrato visual único para las barras que integran navegación lateral. */\n  .platform-responsive-navbar {\n    min-height: 64px !important;\n    padding: 4px 12px 4px 8px !important;\n    background: transparent !important;\n    box-shadow: none !important;\n  }\n\n  .platform-responsive-navbar .app-brand-link {\n    min-width: 0;\n    flex: 1 1 auto;\n  }\n\n  .platform-responsive-navbar .app-brand-link img {\n    width: min(190px, 100%);\n    height: 56px !important;\n    object-fit: contain;\n    object-position: left center;\n  }\n\n  .platform-responsive-navbar .navbar-nav-right {\n    position: static;\n    transform: none;\n    flex: 0 0 auto;\n  }\n\n  .platform-responsive-navbar .navbar-actions {\n    gap: 4px;\n  }\n\n  .custom-navbar-admin > .platform-navbar-menu-toggle {\n    display: inline-flex;\n  }\n}\n\n/* Preview zona horaria (dropdown/offcanvas usuario) */\n.timezone-preview {\n  margin: 4px 0 8px;\n  padding: 6px 8px;\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.timezone-preview-line {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  line-height: 1.25;\n  margin-bottom: 0;\n}\n\n.timezone-preview-zone {\n  color: #516783;\n  font-size: 11px;\n  font-weight: 500;\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.timezone-preview-clock {\n  color: #2d3f58;\n  font-size: 11px;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n/* Dropdown usuario: hover ocupa la fila completa */\n.navbar-dropdown .dropdown-menu>li {\n  margin: 0;\n  padding: 0;\n}\n\n.navbar-dropdown .dropdown-menu>li>a.dropdown-item,\n.navbar-dropdown .dropdown-menu>li>button.dropdown-item {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  margin: 0;\n  padding: 10px 16px;\n  border-radius: 0;\n  box-sizing: border-box;\n}\n\n.navbar-dropdown .dropdown-menu>li>a.dropdown-item:hover,\n.navbar-dropdown .dropdown-menu>li>button.dropdown-item:hover,\n.navbar-dropdown .dropdown-menu>li>a.dropdown-item:focus,\n.navbar-dropdown .dropdown-menu>li>button.dropdown-item:focus {\n  background-color: #edf3fb;\n}\n\n/* Si hay estilos del template que esconden/rompen el img */\n#avtarIcon,\n#avtarIcon img {\n  max-width: none !important;\n  overflow: visible !important;\n}\n\n/* =========================\n   NOTIFICACIONES (DESKTOP)\n========================= */\n#notificationDropdown {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  width: 520px;\n  max-height: calc(100vh - 200px);\n  z-index: 2500;\n  background: #fff;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n/* ✅ Notificaciones: nunca se sale del contenedor (desktop + mobile) */\n#notificationDropdown,\n#notificationDropdown * {\n  box-sizing: border-box;\n}\n\n/* Evita scroll horizontal en el panel */\n#notificationDropdown {\n  overflow-x: hidden !important;\n}\n\n/* El contenedor scroll interno también sin X */\n#notificationDropdown .dropdown-body-scroll {\n  overflow-x: hidden !important;\n}\n\n/* Cada item: permite partir palabras largas */\n.notification-item {\n  width: 100%;\n  min-width: 0;\n  /* CLAVE en layouts flex */\n  overflow: hidden;\n}\n\n.notification-title {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  min-width: 0;\n  /* CLAVE para que el texto envuelva */\n}\n\n.notification-title-text,\n.notification-item strong,\n.notification-item div,\n.notification-item span {\n  white-space: normal !important;\n  overflow-wrap: anywhere;\n  /* rompe cadenas largas */\n  word-break: break-word;\n}\n\n/* =========================\n   SOLICITUDES (LISTA)\n   - fuerza 100% ancho\n   - evita desbordes\n========================= */\n\n/* UL contenedor siempre 100% */\n#notificationDropdown ul,\n.offcanvas-body ul {\n  width: 100%;\n  margin: 0;\n  padding: 0;\n}\n\n/* LI solicitud ocupa TODO el ancho */\n.solicitudesResponsive {\n  width: 100% !important;\n  display: flex !important;\n  align-items: stretch !important;\n  gap: 10px;\n  list-style: none !important;\n  box-sizing: border-box;\n}\n\n/* Quita limitaciones típicas de .dropdown-item (bootstrap) */\n#notificationDropdown .dropdown-item.solicitudesResponsive {\n  white-space: normal !important;\n}\n\n/* Contenedor de textos (el div con flexDirection column) */\n.solicitudesResponsive>div {\n  flex: 1 1 auto !important;\n  min-width: 0 !important;\n  /* CLAVE para ellipsis */\n}\n\n/* Ellipsis para spans (NombreEmpresa / Ruta / Nota) */\n.solicitudesResponsive span {\n  min-width: 0 !important;\n}\n\n/* Botón Aceptar: columna fija sin romper layout */\n.solicitudesResponsive .btn-aceptar {\n  flex: 0 0 auto !important;\n  align-self: stretch;\n  white-space: nowrap;\n  padding: 0 12px !important;\n  border-left: 1px solid #111 !important;\n}\n\n/* Si quieres que TODO el item sea clickeable sin “huecos” */\n.solicitudesResponsive:hover {\n  background: rgba(0, 0, 0, 0.03);\n}\n\n\n\n\n/* =========================\n   MOBILE (SIDEBAR 64px)\n========================= */\n@media (max-width: 768px) {\n\n  .platform-responsive-navbar {\n    min-height: 60px !important;\n    padding: 4px 8px !important;\n  }\n\n  .platform-responsive-navbar .app-brand-link img {\n    width: min(172px, 100%);\n    height: 48px !important;\n  }\n\n  /* Navbar estable */\n  .custom-navbar-admin {\n    min-height: 80px;\n    padding: 0 8px;\n  }\n\n  /* Reduce el logo en mobile para que no empuje campana/avatar */\n  .custom-navbar-admin .app-brand-link img {\n    height: 56px !important;\n    max-width: 180px;\n    object-fit: contain;\n  }\n\n  /* 👉 Bloque derecho SIEMPRE visible */\n  .custom-navbar-admin .navbar-nav-right {\n    position: absolute;\n    top: 50%;\n    right: 8px;\n    transform: translateY(-50%);\n    z-index: 3000;\n  }\n\n  /* Ajuste de espacio entre íconos */\n  .custom-navbar-admin .navbar-nav-right .navbar-actions {\n    gap: 8px;\n  }\n\n  /* Oculta username en mobile */\n  .custom-navbar-admin .navbar-nav-right .fw-semibold {\n    display: none !important;\n  }\n\n  /* =========================\n     PANEL FULLSCREEN NOTIFICACIONES\n     (respeta sidebar 64px)\n  ========================= */\n  #notificationDropdown.dropdown-panel {\n    position: fixed !important;\n    top: 80px !important;\n    /* debajo del navbar */\n    left: 64px !important;\n    /* sidebar */\n    right: 0 !important;\n    bottom: 0 !important;\n\n    width: auto !important;\n    max-width: none !important;\n    min-width: 0 !important;\n\n    border-radius: 0 !important;\n    border: 0 !important;\n    box-shadow: none !important;\n\n    display: flex !important;\n    flex-direction: column !important;\n    overflow: hidden !important;\n\n    background: #fff !important;\n    z-index: 2600 !important;\n  }\n\n  /* Backdrop SIN cubrir sidebar */\n  .dropdown-panel-backdrop {\n    position: fixed;\n    top: 80px;\n    left: 64px;\n    /* sidebar */\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.25);\n    z-index: 2500;\n  }\n\n  /* Header fijo */\n  .dropdown-panel-header {\n    position: sticky;\n    top: 0;\n    background: #fff;\n    z-index: 2;\n    padding: 10px 12px;\n    border-bottom: 1px solid #ddd;\n  }\n\n  /* Body scroll */\n  .dropdown-panel-body {\n    flex: 1;\n    overflow-y: auto;\n    padding: 10px;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  /* Evita bugs de Bootstrap */\n  .dropdown-menu[data-popper-placement] {\n    transform: none !important;\n  }\n\n  .inputSearchNotifiaciones {\n    width: 90% !important;\n  }\n\n  .backdrop-offcanvas-user.show {\n    left: 64px !important;\n    width: calc(100vw - 64px) !important;\n  }\n\n  .offcanvas.custom-offcanvas-user {\n    left: 64px !important;\n    max-width: calc(100vw - 64px) !important;\n  }\n\n  .solicitudesResponsive {\n    padding: 12px 10px !important;\n  }\n\n  .solicitudesResponsive .btn-aceptar {\n    padding: 0 10px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
